import type { ReactNode } from "react";
import { Card } from "../primitives/card";

export interface AccountFact {
  term: string;
  value: string;
}

/**
 * The party's own section of the Account page, beneath "Your sign-in", the same in both portals: a heading, then a
 * card titled with the party's name, each fact as its label over its value with a rule between, an optional action
 * (the customer admin's link to the users page) and a closing note on who manages access.
 */
export function AccountFactsSection({
  heading,
  title,
  facts,
  action,
  note,
}: {
  heading: string;
  title: string;
  facts: AccountFact[];
  action?: ReactNode;
  note: string;
}) {
  return (
    <section className="space-y-3.5">
      <h2 className="text-[15px] font-semibold">{heading}</h2>
      <Card className="gap-3 p-5">
        <h3 className="text-sm font-semibold">{title}</h3>
        <dl>
          {facts.map((fact) => (
            <div
              key={fact.term}
              className="flex flex-col gap-px border-t py-[11px]"
            >
              <dt className="text-sm font-semibold">{fact.term}</dt>
              <dd className="text-[12.5px] text-muted-foreground">
                {fact.value}
              </dd>
            </div>
          ))}
        </dl>
        {action}
        <p className="text-[13px] text-muted-foreground">{note}</p>
      </Card>
    </section>
  );
}
